import { createCompany, updateCompany } from '../providers/api/company/companyProvider';
import { Company } from '../providers/api/dtos';
import { CompanyFormModel } from './components/company-form/CompanyForm';
import { companyFormModelToCompany } from './components/company-form/mappers';

export default async function createOrUpdateCompany(company?: Company, values?: CompanyFormModel): Promise<Company> {
  if (!values && !company) {
    throw new Error('One of company or values parameter is mandatory.');
  }

  if (values && !company) {
    const companyToCreate = companyFormModelToCompany(values);

    return createCompany(companyToCreate);
  }

  if (company?.id && values) {
    const companyToUpdate = companyFormModelToCompany(values);

    return updateCompany(company.id, {
      ...company,
      ...companyToUpdate,
    });
  }

  return Promise.resolve(company!);
}
